import { Validator } from '../../Validator';
import { ValidatorInterface } from '../../ValidatorInterface';
import { ValidatorRegistry } from '../../ValidatorRegistry';
import { PropertiesInterface } from '../Property';
import { ITypeValidatesLessThan } from './ITypeValidatesLessThan';

export class LessThanValidator
  implements ValidatorInterface<ITypeValidatesLessThan>
{
  name = 'LessThan';

  friendlyName = 'Less Than';

  arrayOnly = false;

  array = false;

  description = 'Field must be less than this other field.';

  types = ['Percentage', 'Currency', 'Number', 'DateTime', 'Time', 'Date'];

  properties = {
    value: {
      type: 'Key',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  } as PropertiesInterface;

  constructor(public config?: Validator) {}

  attach(type: ITypeValidatesLessThan) {
    type.addLessThanValidator(this);
  }
}

const lessThanValidator = new LessThanValidator(undefined);

ValidatorRegistry.register(LessThanValidator, lessThanValidator.name);

export { lessThanValidator };
